/*
 * Registers the GroovLens service worker.
 *
 * Behavior:
 *   - Only runs in production-ish environments where the SW makes sense.
 *     We skip if `navigator.serviceWorker` is unavailable.
 *   - Registers `/sw.js` (served from `public/`) at the site root scope.
 *   - On an `updatefound`, we listen for the new SW to reach 'installed'
 *     and (if there's already a controller) tell it to take over.
 *   - Soft-fails on errors — service workers must never block app startup.
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  // Wait until the page is loaded so SW registration doesn't compete with
  // critical resources.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((reg) => {
        // Force an update check on every load so users always run latest.
        try { reg.update(); } catch (_) {
          // Non-fatal — update check is best-effort
        }

        if (!reg) return;
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              // A new SW is waiting — claim immediately.
              try { sw.postMessage({ type: 'SKIP_WAITING' }); } catch (_) {
                // Non-fatal — SW will activate on next page load anyway
              }
            }
          });
        });
      })
      .catch(() => {
        // Silent — SW is a progressive enhancement.
      });
  });
}
